import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { MCFormatTextPipe } from "@maslul/common-services";


@Component({
    selector: 'mi-not-found',
    imports: [
        MCFormatTextPipe
    ],
    templateUrl: './not-found.html',
    styleUrl: './not-found.scss',
    encapsulation: ViewEncapsulation.None
})
export class NotFoundComponent implements OnInit {
    subscription: Subscription = new Subscription();
    errorText: any;

    constructor(
        private translateService: TranslateService) {

    }


    ngOnInit() {
        this.initText();
    }


    initText() {

        this.subscription.add(this.translateService.stream('error').subscribe(translation => {
            this.errorText = translation;
        }));

    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}


